import ReactGA from "react-ga4";
import * as api from "api";
import reportActions from "containers/BudgetHome/Overview/_actions";

export const runScenario = (analysis) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Scenario Tool",
            action: "Run Scenario",
        });
        return dispatch(
            api.post({
                path: `farms/${analysis.farmId}/runmodel`,
                content: analysis,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [];
                },
            })
        );
    });
};

export const setPlanningReport = (scenarios) => ({ type: reportActions.PLANNING_DATA_SET, payload: scenarios });
